import { render, staticRenderFns } from "./StandardsPage.vue?vue&type=template&id=32c52a07&scoped=true"
import script from "./StandardsPage.vue?vue&type=script&lang=js"
export * from "./StandardsPage.vue?vue&type=script&lang=js"
import style0 from "./StandardsPage.vue?vue&type=style&index=0&id=32c52a07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c52a07",
  null
  
)

export default component.exports